import { render } from "./menuBar.vue?vue&type=template&id=d695e72e"
import script from "./menuBar.vue?vue&type=script&lang=js"
export * from "./menuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__